

(function faqProduitSeo () {
   const isCompExists = GlobalSite.checkDependency("GlobalSite.isCompExists");
   const compName = "faq-produit-seo";
   const logFactory = GlobalSite.checkDependency("GlobalSite.logFactory");
   const Log = logFactory(`${compName}.js`);

    if (!isCompExists(compName, Log)) {
      return;
    }

    $(() => {
    })

    })()